



import { defineComponent } from "@vue/composition-api";
import Vue, { VueConstructor } from "vue";
import { getMoreMenuItem } from "@/views/PageMore/components/MoreMenuItem/index";
import { IMoreMenuItem } from "@/views/PageMore/config";

export default defineComponent({
  name: "MoreMenuItem",
  props: {
    item: { type: Object as () => IMoreMenuItem, required: true },
  },
  computed: {
    itemComponent(): VueConstructor<Vue> {
      return getMoreMenuItem(this.item);
    },
  },
});
